import React, {useEffect, useRef, useState } from 'react';
import BarsIcon from '../icons/BarsIcon';
import { useLocation, useNavigate } from 'react-router-dom';
import LanguageToggle from '../icons/LanguageToggle';
import { useAppSelector } from '../../utils/storeHooks';


const HeaderSpace = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const {lang} = useAppSelector(store => store.display);
    const isMāori = lang === 'ma';

    // const [isVisible, setIsVisible] = useState(true);
    // const lastScrollY = useRef(0);
    // const scrollAscentOrigin: React.RefObject<null | number> = useRef(null);
    
    const headerRef = useRef<HTMLDivElement | null>(null);
    const [top, setTop] = useState(0);

    useEffect(() => {
        let lastScrollY = window.scrollY;
    
        const handleScroll = () => {
          if (!headerRef.current) return;
    
          const headerHeight = headerRef.current.offsetHeight;
          const currentScrollY = window.scrollY;
    
          // Positive when scrolling down
          // Negative when scrolling up
          const delta = currentScrollY - lastScrollY;
    
          setTop((prevTop) => {
            // Move header opposite to scroll direction
            let nextTop = prevTop - delta;
    
            // Clamp between fully hidden and fully visible
            nextTop = Math.min(0, Math.max(-headerHeight, nextTop));
    
            return nextTop;
          });
    
          lastScrollY = currentScrollY;
        };
    
        window.addEventListener("scroll", handleScroll, { passive: true });
    
        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    let bug;
    
    if (location.pathname.length === 1) {
        bug = <></>;
    } else {
        bug = <h1 className='cursor-pointer' onClick={() => navigate('/')}>tukutuku</h1>;
    }

    return (
        <div ref={headerRef} className="z-90 py-2 px-2 w-screen flex-aho place-content-between bg-kaho-2 fixed left-0 right-0 overflow-visible transition-slow" style={{top: `${top}px`}}>
            <div className="flex-aho w-fit md:w-3/7 text-toto-0">
                <BarsIcon />
                {bug}
            </div>
            <LanguageToggle reo={isMāori} />
        </div>
    )
}

export default HeaderSpace
